import { Link } from "react-router-dom";
import { mangas } from "@/mocks/mangas";

const featured = [...mangas].sort((a, b) => b.rating - a.rating).slice(0, 8);

export default function MangaGrid() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6" aria-labelledby="featured-heading">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <span className="text-sm font-medium text-accent-600">FEATURED</span>
          <h2 id="featured-heading" className="mt-1 font-heading text-2xl text-foreground-900 md:text-3xl">
            高分漫画推荐大全
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            精选口碑与人气俱佳的漫画作品，涵盖多种漫画题材分类，供你快速发现佳作。
          </p>
        </div>
        <Link
          to="/category"
          className="group flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          浏览更多
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4">
        {featured.map((m) => (
          <Link
            key={m.slug}
            to={`/category/${m.category}`}
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="relative h-52 w-full overflow-hidden md:h-60">
              <img
                src={m.cover}
                alt={m.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <span className="absolute left-2 top-2 rounded-full bg-black/50 px-2 py-0.5 text-xs text-white backdrop-blur">
                {m.status}
              </span>
              <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
                <i className="ri-star-fill" />
                {m.rating}
              </span>
            </div>
            <div className="p-4">
              <h3 className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600 md:text-base">
                {m.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {m.categoryName} · {m.chapters} 话
              </p>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{m.intro}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}